package diana.soleil.design.iraniancanadienbazzar.core.data

import diana.soleil.design.iraniancanadienbazzar.core.model.PickedImage

/**
 * Bridges the platform image picker (system photo picker on Android/iOS, a file input on Web) into
 * shared code. The actual picker is a suspend lambda injected from each entry point via `App(...)`,
 * exactly like `getUserLocation`/`shareText`. Returns null when the user cancels.
 */
class ImagePickController(private val picker: suspend () -> PickedImage?) {
    suspend fun pick(): PickedImage? = picker()
}
